import HeaderLinks from './HeaderLinks.component';

export default HeaderLinks;
